module.exports = __webpack_public_path__ + "img/trash.e79dac5f.svg";